module.exports = __webpack_public_path__ + "img/Paseos.3d966fc5.jpg";